"use strict";

module.exports = function (params) {
  delete params.savedsearchid;
  delete params.page;

  return params;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/lib/resetSearchParams.js
 ** module id = 451
 ** module chunks = 0
 **/